import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { SharedAnalyticsService } from '../../../analytics/shared-analytics/shared-analytics.service';
import { EAnalyticsHeaderLabels } from '../../../enums/analytics.enum';
import { SECTIONS } from '../../../models/Constants';

@Component({
  selector: 'getm-deadline-status',
  templateUrl: './deadline-status.component.html',
  styleUrls: ['./deadline-status.component.scss'],
})
export class DeadlineStatusComponent implements OnInit {

  @Input() cardBackground: string = 'getm-background-status-blue';
  @Input() iconName: string = 'getm-pricetag';
  @Input() iconColor: string = 'getm-category-pedido-sugerido';
  @Input() topText: string = '';
  @Input() topTextColor: string = 'getm-information-light';
  @Input() bottomText: string = '';
  @Input() bottomTextColor: string = 'getm-information-light';

  @Output() btnClick = new EventEmitter<void>();

  constructor(private sharedAnalyticsS: SharedAnalyticsService) { }

  ngOnInit(): void { }

  public onButtonClick = () => {
    this.btnClick.emit();
    this.sharedAnalyticsS.trackInteractionHeader({
      section: SECTIONS.TIENDA,
      label: EAnalyticsHeaderLabels.VER_ACTIVIDAD
    });
  };

}
